const NAMESPACE = 'FEATURES';

export const REQUEST_FEATURE_CONFIG = `${NAMESPACE}/REQUEST_LOG`;
export const REQUEST_FEATURE_CONFIG_SUCCEED = `${NAMESPACE}/REQUEST_FEATURE_CONFIG_SUCCEED`;

export const FEATURE_MANUALLY_ADD_CANDIDATE = 'MANUALLY_ADD_CANDIDATE';
export const FEATURE_LINK_BUILDER = 'LINK_BUILDER';
